import { Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material';
import { FeatFlipRoadComponent } from 'app/components/feat-flip-road/feat-flip-road.component';
import { Subject } from 'rxjs';
import { ActivityService } from './activity.service';
import { CommonModalService } from './common-modal.service';
import { EditToolService, NeutralColumn } from './edit-tool.service';
import { MainDataService } from './main-data.service';

export interface FlipRoadInput {
	cols: FlipRoadColumn[];
	record;
}
export interface FlipRoadOutput {
	cols?: FlipRoadColumn[];
	cancel?: boolean;
}
export interface FlipRoadColumn extends NeutralColumn {
	isTransposed?: boolean;
}
export interface AfterFlipData {
	id;
	transposeCols?: FlipRoadColumn[];
	flipedWkt?: string;
}

@Injectable({
  providedIn: 'root'
})
export class FlipRoadService {


	flipRoadSubject: Subject<{
		id?; // if id isn't passed, flip current card
		transposeCols?: FlipRoadColumn[];
		geom?: boolean;
	}> = new Subject();
	afterFlipRoadSubject: Subject<AfterFlipData> = new Subject();

	constructor(
		private activityService: ActivityService,
		private editToolService: EditToolService,
		private mainDataService: MainDataService,
		private modalService: CommonModalService
	) { }
	async flipRoadAttrs(rec?) {
		const columns = this.mainDataService.currentColumns;
		const flipRoadCols: FlipRoadColumn[] = this.editToolService.transformLeftRightColumnsToNeutral(columns);
		// columns.forEach(c => {
		// 	if (c.prop.endsWith('_l') || c.prop.endsWith('_r')) {
		// 		const propWithoutDirection = c.prop.substring(0, c.prop.length - 2);
		// 		const lastSpaceIdx = c.name.lastIndexOf(' ');
		// 		const neutralName = c.name.substring(0, lastSpaceIdx);
		// 		let col: FlipRoadColumn = flipRoadCols.find(fc => fc.propWithoutDirection === propWithoutDirection);
		// 		if (!col) {
		// 			col = {
		// 				leftProp: null,
		// 				leftName: null,
		// 				rightProp: null,
		// 				rightName: null,
		// 				neutralName: neutralName,
		// 				propWithoutDirection: propWithoutDirection
		// 			};
		// 			flipRoadCols.push(col);
		// 		}
		// 		if (c.prop.endsWith('_l')) {
		// 			col.leftProp = c.prop;
		// 			col.leftName = c.name;
		// 		} else {
		// 			col.rightProp = c.prop;
		// 			col.rightName = c.name;
		// 		}
		// 	}
		// });
		if (!rec) {
			const currentCardInfo = this.activityService.currentCardBS.getValue();
			rec = this.mainDataService.getDataAttrs(currentCardInfo.id);
		}

		const data: FlipRoadInput = {
			cols: flipRoadCols,
			record: rec
		};
		const options: MatDialogConfig = {
			data: data,
			width: '450px',
			height: '600px'
		}
		const rsp: FlipRoadOutput = await this.modalService.openModalWindow(FeatFlipRoadComponent, options);
		return rsp;
	}
}
